var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "searchBox_top" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.approvalSuppliers },
            },
            [_vm._v(_vm._s(_vm.$t("supplierManage.SuppliersApproval")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.historyBack } },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ],
        1
      ),
      _vm.supplierCode
        ? _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("supplierManage.supplierCategoryInfo"))
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form",
                {
                  ref: "CategoryInfoForm",
                  attrs: {
                    model: _vm.CategoryInfoForm,
                    rules: _vm.CategoryInfoRules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Category1", prop: "Category1" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.CategoryInfoForm.Category1,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.CategoryInfoForm,
                                    "Category1",
                                    $$v
                                  )
                                },
                                expression: "CategoryInfoForm.Category1",
                              },
                            },
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  label: "美食/餐厅线上活动",
                                  name: "Category1",
                                },
                              }),
                              _c("el-checkbox", {
                                attrs: { label: "地推活动", name: "Category1" },
                              }),
                              _c("el-checkbox", {
                                attrs: {
                                  label: "线下主题活动",
                                  name: "Category1",
                                },
                              }),
                              _c("el-checkbox", {
                                attrs: {
                                  label: "单纯品牌曝光",
                                  name: "Category1",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Category2", prop: "Category2" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.CategoryInfoForm.Category2,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.CategoryInfoForm,
                                    "Category2",
                                    $$v
                                  )
                                },
                                expression: "CategoryInfoForm.Category2",
                              },
                            },
                            [
                              _c("el-checkbox", {
                                attrs: {
                                  label: "美食/餐厅线上活动",
                                  name: "Category2",
                                },
                              }),
                              _c("el-checkbox", {
                                attrs: { label: "地推活动", name: "Category2" },
                              }),
                              _c("el-checkbox", {
                                attrs: {
                                  label: "线下主题活动",
                                  name: "Category2",
                                },
                              }),
                              _c("el-checkbox", {
                                attrs: {
                                  label: "单纯品牌曝光",
                                  name: "Category2",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("supplierManage.supplierBasicInfo"))),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "queryCondition",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.supplierChinese"),
                            prop: "supplierChinese",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.queryCondition.supplierChinese,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "supplierChinese",
                                  $$v
                                )
                              },
                              expression: "queryCondition.supplierChinese",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "supplierManage.supplierAbbreviation"
                            ),
                            prop: "supplierEnglish",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.queryCondition.supplierEnglish,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "supplierEnglish",
                                  $$v
                                )
                              },
                              expression: "queryCondition.supplierEnglish",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "supplierManage.supplierInvitationCode"
                            ),
                            prop: "supplierEnglish",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.queryCondition.supplierEnglish,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "supplierEnglish",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryCondition.supplierEnglish",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.auditStatus"),
                            prop: "supplierEnglish",
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              clearable: "",
                              table: "BASE",
                              field: "DC",
                            },
                            model: {
                              value: _vm.queryCondition.processNode,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "processNode", $$v)
                              },
                              expression: "queryCondition.processNode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.supplierEnglish"),
                            prop: "supplierEnglish",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.queryCondition.supplierEnglish,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "supplierEnglish",
                                  $$v
                                )
                              },
                              expression: "queryCondition.supplierEnglish",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.supplierType"),
                            prop: "supplierEnglish",
                          },
                        },
                        [
                          _c("ic-select", {
                            attrs: {
                              clearable: "",
                              table: "BASE",
                              field: "DC",
                            },
                            model: {
                              value: _vm.queryCondition.processNode,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "processNode", $$v)
                              },
                              expression: "queryCondition.processNode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("supplierManage.supplierInviter"),
                            prop: "supplierEnglish",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.queryCondition.supplierEnglish,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryCondition,
                                  "supplierEnglish",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "queryCondition.supplierEnglish",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.addSupplierContacts },
            },
            [_vm._v(_vm._s(_vm.$t("common.add")))]
          ),
          _c(
            "el-table",
            {
              ref: "contactsList",
              attrs: {
                data: _vm.contactsList,
                border: "",
                "highlight-current-row": "",
                "max-height": "420",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "templateName",
                  label: _vm.$t("supplierManage.supplierContacts"),
                },
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("base.linePrice.operation") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.$index != 0
                          ? _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.delSupplierContacts(
                                      scope.$index,
                                      _vm.contactsList,
                                      scope.row
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("common.del")))]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("supplierManage.confidentialityAgreement"))),
            ]),
          ]
        ),
      ]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("supplierManage.supplierAddressInfo"))),
            ]),
          ]
        ),
      ]),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              staticStyle: { display: "flex", "align-items": "center" },
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t("common.otherAttachments")))]),
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticStyle: { "margin-left": "20px" },
                  attrs: {
                    action: "upload",
                    "http-request": _vm.uploadConfirm,
                    "show-file-list": false,
                    multiple: "",
                    name: "file",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "trigger",
                        size: "small",
                        type: "primary",
                      },
                      slot: "trigger",
                    },
                    [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: {
                data: _vm.fileList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "documentName",
                  label: _vm.$t("common.file"),
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.downloadFile(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.documentName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "userName",
                  label: _vm.$t("common.createBy"),
                  "min-width": "130px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  sortable: "",
                  prop: "createDate",
                  label: _vm.$t("common.createDate"),
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("dateFormatFilter")(
                                scope.row.createDate,
                                "YYYY-MM-DD HH:mm"
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "tmDocumentId", "min-width": "130px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            nativeOn: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.deleteFile(
                                  scope.row.tmDocumentId,
                                  scope.$index,
                                  _vm.fileList
                                )
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.del")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("supplierManage.approvalWindow"),
            visible: _vm.approvalVisible,
            width: "25%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.approvalVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "approvaForm",
              attrs: {
                model: _vm.approvaForm,
                rules: _vm.approvaRules,
                inline: "",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("storeFeedback.auditor"),
                    prop: "auditor",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.auditor,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "auditor", $$v)
                      },
                      expression: "approvaForm.auditor",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalTime"),
                    prop: "approvalTime",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.approvaForm.approvalTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalTime", $$v)
                      },
                      expression: "approvaForm.approvalTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalResults"),
                    prop: "approvalResults",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.ResultsChange },
                      model: {
                        value: _vm.approvaForm.approvalResults,
                        callback: function ($$v) {
                          _vm.$set(_vm.approvaForm, "approvalResults", $$v)
                        },
                        expression: "approvaForm.approvalResults",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v(_vm._s(_vm.$t("common.pass"))),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v(_vm._s(_vm.$t("common.noPass"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("common.approvalRemarks"),
                    prop: "approvalRemarks",
                    rules:
                      _vm.approvaForm.approvalResults == 2
                        ? _vm.approvaForm.approvalRemarks
                        : [],
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                      maxlength: "300",
                    },
                    model: {
                      value: _vm.approvaForm.approvalRemarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.approvaForm, "approvalRemarks", $$v)
                      },
                      expression: "approvaForm.approvalRemarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.approvalVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.approvalConfirm()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }